module.exports = __webpack_public_path__ + "img/32202502.455051ad.png";